export enum CredentialsType {
    Admin,
    Operator,
    Viewer,
}
